/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Clock_LabelInputs */

const en_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clock`)
};

const fr_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horloge`)
};

const de_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhr`)
};

const it_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orologio`)
};

const ru_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы`)
};

const es_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reloj`)
};

const zh_cn2_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`钟`)
};

const ja_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クロック`)
};

const hi_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घड़ी`)
};

const pt_pt2_summary_clock_label = /** @type {(inputs: Summary_Clock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relógio`)
};

/**
* | output |
* | --- |
* | "Clock" |
*
* @param {Summary_Clock_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_clock_label = /** @type {((inputs?: Summary_Clock_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Clock_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_clock_label(inputs)
	if (locale === "de") return de_summary_clock_label(inputs)
	if (locale === "it") return it_summary_clock_label(inputs)
	if (locale === "ru") return ru_summary_clock_label(inputs)
	if (locale === "es") return es_summary_clock_label(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_clock_label(inputs)
	if (locale === "ja") return ja_summary_clock_label(inputs)
	if (locale === "hi") return hi_summary_clock_label(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_clock_label(inputs)
	return en_summary_clock_label(inputs)
});